module.exports = __webpack_public_path__ + "img/home_ar.90fbf7ec.png";